const TYPES = {
  CreateJobService: Symbol.for("CreateJobService"),
  IJobRepository: Symbol.for("IJobRepository"),
  IUserRepository: Symbol.for("IUserRepository"),
  ISoftwareSettingsRepository: Symbol.for("ISoftwareSettingsRepository"),
  ISoftwareVersionsRepository: Symbol.for("ISoftwareVersionsRepository"),
  IStorageLocationsRepository: Symbol.for("IStorageLocationsRepository"),
  IAuthenticatedRequestHandlerService: Symbol.for("IAuthenticatedRequestHandlerService"),
  IFastaRepository: Symbol.for("IFastaRepository"),
  UploadFastaService: Symbol.for("UploadFastaService"),
  ListFastaService: Symbol.for("ListFastaService"),
  IInventoryRepository: Symbol.for("IInventoryRepository"),
  ListJobsService: Symbol.for("ListJobsService"),
  ListJobTasksService: Symbol.for("ListJobTasksService"),
  IPipelineRepository: Symbol.for("IPipelineRepository"),
  ListPipelineService: Symbol.for("ListPipelineService"),
  GetRawFileListService: Symbol.for("GetRawFileListService"),
  SaveLicenseService: Symbol.for("SaveLicenseService"),
  ILicenseRepository: Symbol.for("ILicenseRepository"),
  IAuthService: Symbol.for("IAuthService"),
  IRawFileRepository: Symbol.for("IRawFileRepository"),
  ChangePassword: Symbol.for("ChangePassword"),
  IResultsRepository: Symbol.for("IResultsRepository"),
  DeleteFastaService: Symbol.for("DeleteFastaService"),
  DeleteSoftwareSettingsService: Symbol.for("DeleteSoftwareSettingsService"),
  UploadRawFileService: Symbol.for("UploadRawFileService"),
  DeleteRawFileService: Symbol.for("DeleteRawFileService"),
  LibraryRepository: Symbol.for("LibraryRepository"),
  UploadLibraryService: Symbol.for("UploadLibraryService"),
};

export { TYPES };
